import { useMemo } from 'react';
import { useTenant } from '../contexts/TenantContext';

function pluralise(s) {
  if (!s) return s;
  return s.endsWith('s') ? s : s + 's';
}

export function useLabels() {
  const { profile } = useTenant();
  return useMemo(() => {
    const lo = profile?.label_overrides ?? {};
    const sales = lo.sales || 'Sales';
    const customer = lo.customer || 'Customer';
    const product = lo.product || 'Product';
    const invoice = lo.invoice || 'Invoice';
    const inventory = lo.inventory || 'Inventory';
    return {
      sales,
      customer,
      customers: pluralise(customer),
      product,
      products: pluralise(product),
      invoice,
      invoices: pluralise(invoice),
      inventory,
    };
  }, [profile?.label_overrides]);
}
